import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles, createStyles, Button } from "@material-ui/core";
import CancelIcon from "@material-ui/icons/CancelOutlined";
import CheckIcon from "@material-ui/icons/CheckCircleOutline";
import { ITheme } from "../../Layout/themes";
import { commonStaticContentStyles } from "./index";
import { Text } from "../../Ui/Text";
import { addToken } from "../../../commons/utils/addToken";

const useStyles = makeStyles(({ palette }: ITheme) => {
  return createStyles({
    root: {
      maxWidth: 252,
      marginLeft: "auto",
      marginRight: "auto",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "80vh"
    },
    cancelIcon: {
      ...commonStaticContentStyles.headerIcon,
      color: palette.error.dark
    },
    checkIcon: {
      ...commonStaticContentStyles.headerIcon,
      color: palette.success.dark
    },
    headingText: {
      ...commonStaticContentStyles.headingText,
      lineHeight: 1.17,
      textAlign: "center",
      marginBottom: "3rem"
    },
    homeButton: {
      ...commonStaticContentStyles.button,
      color: palette.secondary.main
    },
    viewTicketButton: {
      ...commonStaticContentStyles.button,
      backgroundColor: palette.success.main,
      color: "#fff",
      marginBottom: "1rem",
      "&:hover": {
        backgroundColor: palette.success.dark
      }
    }
  });
});

export enum StaticContentTypes {
  REJECTED = "REJECTED",
  INVALID_TICKET = "INVALID_TICKET",
  ACCEPTED = "ACCEPTED"
}

export const createStaticContent = (
  staticContentType: StaticContentTypes,
  env
) => () => {
  const [btnDisabled, setBtnDisabled] = useState<boolean>(false);
  const classes = useStyles({});
  const location = useLocation();
  const invalidTicket = staticContentType === StaticContentTypes.INVALID_TICKET;
  const accepted = staticContentType === StaticContentTypes.ACCEPTED;
  const rejected = staticContentType === StaticContentTypes.REJECTED;


  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const handleRedirect2MobilTicket = () => {
    const index = location.search.indexOf("mobiUrl=");
    if (index > -1) {
      const url = location.search.slice(index + "mobiUrl=".length);
      setBtnDisabled(true);
      window.location.href = addToken(url);
    }
  };
  const handleRedirect2Homepage = (environment) => {
    window.location.href = environment.env.HOMEPAGE_URL;
  };

  return (
    <div className={classes.root}>
      {invalidTicket && <CancelIcon className={classes.cancelIcon} />}
      {accepted && <CheckIcon className={classes.checkIcon} />}
      {rejected && null}
      <Text variant="h5" className={classes.headingText}>
        {invalidTicket && "Sorry, that ticket link is no longer active or has been returned to the purchaser"}
        {rejected && "Ticket has been declined"}
        {accepted && "You have already accepted this ticket"}
      </Text>
      {accepted && (
        <Button
          disabled={btnDisabled}
          variant="contained"
          className={classes.viewTicketButton}
          onClick={handleRedirect2MobilTicket}
        >
          {btnDisabled ? "Loading ticket..." : "View ticket"}
        </Button>
      )}

      <Button
        variant="outlined"
        className={classes.homeButton}
        onClick={() => handleRedirect2Homepage(env)}
      >
        Homepage
      </Button>
    </div>
  );
};

export const InvalidTicketContent = (environment) => createStaticContent(StaticContentTypes.INVALID_TICKET,environment);
export const RejectedContent = (environment) => createStaticContent(StaticContentTypes.REJECTED, environment);
export const AcceptedContent = (environment) => createStaticContent(StaticContentTypes.ACCEPTED, environment);
